import { KeyGroup } from '@libs/types/enum'
import { speciaBehiver, specialCheckCurrent } from './limit'
export interface KeyGroupInfo {
  groupNameTranslationKey: string // 分组的名字，填写翻译对应的key, 比如 "magnet_cyan"
  borderColor: number
  color: number // 代表的颜色
  description: string[] // 描述
}

const keyGroupInfoMap = new Map<KeyGroup, KeyGroupInfo>()
keyGroupInfoMap.set(KeyGroup.cipo, {
  groupNameTranslationKey: 'magnet_factory',
  color: 0xffc935, //0xFFB535
  borderColor: 0xffc935,
  description: [''],
})
keyGroupInfoMap.set(KeyGroup.zixing, {
  groupNameTranslationKey: 'magnet_zixing',
  color: 0xad4de3, //0x733B91,
  borderColor: 0xad4de3,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.tianqing, {
  groupNameTranslationKey: 'magnet_cyan',
  color: 0x50a9ee, //0x498DC2
  borderColor: 0x50a9ee,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.tianqing_Pro, {
  groupNameTranslationKey: 'magnet_tianqing_pro',
  color: 0x85caff, //0x733B91,
  borderColor: 0x85caff,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})

keyGroupInfoMap.set(KeyGroup.ciyu, {
  groupNameTranslationKey: 'magnet_ciyu',
  color: 0x48f2bf, //0x733B91,
  borderColor: 0x48f2bf,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.CiyuPro, {
  groupNameTranslationKey: 'magnet_CiYuPro',
  color: 0x86ffdb,
  borderColor: 0x86ffdb,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.CiyuGaming, {
  groupNameTranslationKey: 'magnet_CiYuGaming',
  color: 0x35e2ae,
  borderColor: 0x35e2ae,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.tianwang_SE, {
  groupNameTranslationKey: 'magnet_tianwang_SE',
  color: 0xff9a4d, //0x733B91,
  borderColor: 0xff9a4d,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.tianwang_Standard, {
  groupNameTranslationKey: 'magnet_tianwang_Standard',
  color: 0xff5ad9, //0x733B91,
  borderColor: 0xff5ad9,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.tianwang_Esports, {
  groupNameTranslationKey: 'magnet_tianwang_Esports',
  color: 0x5a86ff, //0x733B91,
  borderColor: 0x5a86ff,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.wanciwang, {
  groupNameTranslationKey: 'magnet_wanciwang',
  color: 0xf35a5a, //0x733B91,
  borderColor: 0xf35a5a,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.xingguang, {
  groupNameTranslationKey: 'magnet_xingguang',
  color: 0xfff570, // 0x733B91,
  borderColor: 0xfff570,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.qinghui, {
  groupNameTranslationKey: 'magnet_qinghui',
  color: 0xcccccc, // 0x733B91,
  borderColor: 0xcccccc,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.qinghui_pro, {
  groupNameTranslationKey: 'magnet_qinghui_pro',
  color: 0xe4e4e4, // 0xE0E0E0,
  borderColor: 0xe4e4e4,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.TianShanGT, {
  groupNameTranslationKey: 'magnet_TianShanGT',
  color: 0xf26599,
  borderColor: 0xf26599,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})
keyGroupInfoMap.set(KeyGroup.BaBao, {
  groupNameTranslationKey: 'magnet_BaBao',
  color: 0xbd765b,
  borderColor: 0xbd765b,
  description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
})

export const KeyGroupInfoMap = (): Map<KeyGroup, KeyGroupInfo> => {
  if (specialCheckCurrent(speciaBehiver.Device_UnknownAxis)) {
    const map = new Map<KeyGroup, KeyGroupInfo>()
    map.set(KeyGroup.unknown, {
      groupNameTranslationKey: 'magnet_default',
      color: 0xcccccc,
      borderColor: 0xcccccc,
      description: ['magnet_notice_desc1', 'magnet_notice_desc2', 'magnet_notice_desc3'],
    })
    const merged = new Map<KeyGroup, KeyGroupInfo>([...map, ...keyGroupInfoMap])
    return merged
  }
  return keyGroupInfoMap
}

interface KeyGroupDeadZone {
  bottom: number
}
const defaultDeadZone = { bottom: 0 }
const KeyGroupDeadZone: Map<KeyGroup, KeyGroupDeadZone> = new Map([
  [KeyGroup.zixing, { bottom: 0 }],
  [KeyGroup.tianqing, { bottom: 0 }],
])
export const KeyGroupDeadZoneConfig = (keyGroup: KeyGroup) => KeyGroupDeadZone.get(keyGroup) || defaultDeadZone
